package com.fantasytenis.shared.domain.engagement.usecases

import com.fantasytenis.shared.core.utils.SharedData
import com.fantasytenis.shared.domain.engagement.EngagementRepository
import com.fantasytenis.shared.domain.engagement.entity.EngagementEntity

/**
 * Use case for getting user's engagement data.
 * Updates SharedData.engagement on success.
 */
class GetEngagementUseCase(
    private val repository: EngagementRepository
) {
    suspend operator fun invoke(): Result<EngagementEntity> = runCatching {
        val engagement = repository.getMyEngagement()
        // Update shared state
        SharedData.engagement.value = engagement
        engagement
    }
}
